import { h, svgUse } from '../../../utils/dom.js';

export function JourneyCard({ icon, title, desc, badge, actionLabel, variant = 'scenario', onSelect }) {
  return h('button', { class: `journey-card ${variant}-card`, type: 'button', onclick: onSelect },
    h('span', { class: 'jc-badge' }, badge),
    h('div', { class: 'jc-arrow' }, svgUse('ic-chevr', 'flip-x')),
    h('div', { class: 'jc-icon' }, svgUse(icon)),
    h('span', { class: 'jc-copy' },
      h('b', {}, title),
      h('p', {}, desc),
    ),
    h('span', { class: 'jc-action' }, actionLabel, svgUse('ic-chevr', 'flip-x')),
  );
}
